const navCheck = document.querySelector("#nav-check");
const siteHeader = document.querySelector(".site-header");
const mobileLinks = document.querySelectorAll(".mobile-nav a");

mobileLinks.forEach((link) => {
  link.addEventListener("click", () => {
    if (navCheck) navCheck.checked = false;
    if (siteHeader) siteHeader.classList.remove("is-menu-open");
  });
});

if (siteHeader) {
  const mobileHeaderQuery = window.matchMedia
    ? window.matchMedia("(max-width: 860px)")
    : { matches: false };
  let lastScrollY = window.scrollY || 0;
  let lastTouchY = null;
  let isTicking = false;

  const showHeader = () => {
    siteHeader.classList.remove("is-hidden");
    siteHeader.classList.add("is-visible");
  };

  const hideHeader = () => {
    if (mobileHeaderQuery.matches) {
      showHeader();
      return;
    }

    siteHeader.classList.add("is-hidden");
    siteHeader.classList.remove("is-visible");
  };

  const setHeaderState = () => {
    const currentScrollY = Math.max(window.scrollY || window.pageYOffset || 0, 0);
    const delta = currentScrollY - lastScrollY;
    const menuIsOpen = Boolean(navCheck && navCheck.checked);

    if (currentScrollY <= 24 || menuIsOpen || delta < 0) {
      showHeader();
    } else if (delta > 8 && currentScrollY > 140) {
      hideHeader();
    }

    lastScrollY = currentScrollY;
    isTicking = false;
  };

  window.addEventListener(
    "scroll",
    () => {
      if (isTicking) return;
      isTicking = true;
      window.requestAnimationFrame(setHeaderState);
    },
    { passive: true }
  );

  window.addEventListener(
    "touchstart",
    (event) => {
      lastTouchY = event.touches && event.touches.length ? event.touches[0].clientY : null;
    },
    { passive: true }
  );

  window.addEventListener(
    "touchmove",
    (event) => {
      if (!mobileHeaderQuery.matches || lastTouchY === null || !event.touches || !event.touches.length) return;

      const currentTouchY = event.touches[0].clientY;
      if (currentTouchY - lastTouchY > 5) {
        showHeader();
      }

      lastTouchY = currentTouchY;
    },
    { passive: true }
  );

  window.addEventListener(
    "touchend",
    () => {
      lastTouchY = null;
    },
    { passive: true }
  );

  if (navCheck) {
    navCheck.addEventListener("change", () => {
      siteHeader.classList.toggle("is-menu-open", navCheck.checked);
      if (navCheck.checked) {
        showHeader();
      }
    });
  }
}

const productImage = document.querySelector("#ProductMainImage");
const productThumbs = document.querySelectorAll("[data-product-thumb]");

productThumbs.forEach((thumb) => {
  thumb.addEventListener("click", () => {
    if (!productImage) return;

    productThumbs.forEach((item) => item.classList.remove("is-active"));
    thumb.classList.add("is-active");

    productImage.classList.add("is-switching");
    productImage.addEventListener(
      "load",
      () => {
        productImage.classList.remove("is-switching");
      },
      { once: true }
    );

    window.setTimeout(() => {
      productImage.src = thumb.dataset.full;
      if (productImage.complete) {
        window.setTimeout(() => productImage.classList.remove("is-switching"), 120);
      }
    }, 80);

    productImage.alt = thumb.dataset.alt || productImage.alt;
  });
});

const productForms = document.querySelectorAll(".product-form");

productForms.forEach((form) => {
  form.addEventListener("submit", async (event) => {
    const submitter = event.submitter || document.activeElement;
    if (submitter && submitter.classList && !submitter.classList.contains("add-to-bag")) return;
    if (!window.fetch || !window.FormData) return;

    const shopifyRoot =
      window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : "/";
    const rootUrl = shopifyRoot.charAt(shopifyRoot.length - 1) === "/" ? shopifyRoot : `${shopifyRoot}/`;
    const submitButton = form.querySelector(".add-to-bag");
    const cartStatus = form.querySelector("[data-cart-status]");
    const originalText = submitButton ? submitButton.textContent : "";
    const formData = new FormData(form);

    event.preventDefault();
    formData.delete("return_to");

    if (submitButton) {
      submitButton.disabled = true;
      submitButton.textContent = "Adding...";
    }

    if (cartStatus) {
      cartStatus.textContent = "";
    }

    try {
      const response = await fetch(`${rootUrl}cart/add.js`, {
        method: "POST",
        body: formData,
        headers: {
          Accept: "application/json"
        }
      });

      if (!response.ok) {
        throw new Error("Cart add failed");
      }

      window.location.href = `${rootUrl}cart`;
    } catch (error) {
      if (submitButton) {
        submitButton.disabled = false;
        submitButton.textContent = originalText || "Add full system to bag";
      }

      if (cartStatus) {
        cartStatus.textContent = "Could not add this to your bag. Please refresh and try again.";
      }
    }
  });
});

const motionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");

if (!motionQuery.matches) {
  const runPremiumMotion = () => {
    const animeApi = window.anime;
    const animeAnimate = animeApi && (animeApi.animate || (typeof animeApi === "function" ? animeApi : null));
    const animeStagger = animeApi && animeApi.stagger;

    const runAnime = (targets, options) => {
      if (!animeAnimate) return false;
      const items = typeof targets === "string" ? document.querySelectorAll(targets) : targets;
      if (!items || !items.length) return false;

      try {
        animeAnimate(items, options);
        return true;
      } catch (error) {
        return false;
      }
    };

    const entranceItems = document.querySelectorAll(
      [
        ".system-hero-copy > p:not(.hero-note)",
        ".system-hero-copy h1",
        ".system-hero-copy .hero-actions",
        ".system-hero-copy .hero-note",
        ".education-hero-copy .eyebrow",
        ".education-hero-copy h1",
        ".education-hero-copy > p:not(.eyebrow)",
        ".education-hero-copy .hero-actions"
      ].join(",")
    );

    const brandItems = document.querySelectorAll(".brand-name, .brand-by");

    if (
      runAnime(entranceItems, {
        opacity: [0, 1],
        y: [12, 0],
        duration: 720,
        delay: animeStagger ? animeStagger(65, { start: 90 }) : 90,
        ease: "out(3)"
      }) ||
      runAnime(brandItems, {
        opacity: [0, 1],
        y: [-4, 0],
        duration: 520,
        delay: animeStagger ? animeStagger(40) : 0,
        ease: "out(2)"
      })
    ) {
      document.documentElement.classList.add("anime-enhanced");
    }
  };

  if (window.anime) {
    runPremiumMotion();
  } else {
    window.addEventListener("load", runPremiumMotion, { once: true });
  }
}

if (!motionQuery.matches && "IntersectionObserver" in window) {
  const revealItems = document.querySelectorAll(
    [
      ".hero-copy",
      ".signal-strip > div",
      ".collection-section",
      ".brand-story-section",
      ".brand-story-copy",
      ".product-card",
      ".product-section",
      ".ritual-section",
      ".routine-grid li",
      ".collection-ingredients-block",
      ".ingredients-section",
      ".ingredient-grid article",
      ".editorial-row div",
      ".standards-section",
      ".standards-list article",
      ".claims-grid li",
      ".closing-section",
      ".product-hero",
      ".product-summary",
      ".product-info-band > div",
      ".product-story",
      ".bundle-education",
      ".education-ingredient-list article",
      ".product-accordions details",
      ".product-system-cta",
      ".reviews-section",
      ".review-row",
      ".faq-section",
      ".formula-hero",
      ".formula-principle",
      ".ingredient-deep-dive",
      ".ingredient-explain-grid article",
      ".formula-lineage",
      ".formula-routine",
      ".formula-next",
      ".education-hero",
      ".education-hero-copy",
      ".story-manifesto",
      ".story-manifesto-copy",
      ".story-origin",
      ".story-origin-grid article",
      ".story-journey",
      ".story-journey-grid article",
      ".story-values",
      ".story-pillars article",
      ".story-rhythm-section",
      ".ingredient-map-panel",
      ".ingredient-map-points li",
      ".ingredient-tradition",
      ".tradition-grid article",
      ".ingredient-lineage",
      ".lineage-grid article",
      ".ingredient-index",
      ".ingredient-page-grid article",
      ".ingredient-deep-system",
      ".deep-formula-card",
      ".ingredient-role-list div",
      ".ingredient-roles-section",
      ".ingredient-roles-section li",
      ".ingredient-final-cta",
      ".ingredient-page-standards",
      ".site-footer"
    ].join(",")
  );

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add("is-visible");
        observer.unobserve(entry.target);
      });
    },
    {
      rootMargin: "0px 0px -10% 0px",
      threshold: 0.12
    }
  );

  revealItems.forEach((item) => {
    item.classList.add("reveal-target");
    observer.observe(item);
  });
} else {
  document.documentElement.classList.add("motion-reduced");
}
